import { FC } from 'react';

import { TablePagination } from 'modules/_shared/Table/components/TablePagination';

import { useMyFolders } from '../context/MyFolders';
import FolderCard from './FolderCard';

const RootFoldersView: FC = () => {
  const { data, actions } = useMyFolders();

  const showPagination = data.foldersCount > 15;

  return (
    <>
      <div className="folder-grid">
        {data.folders.map((folder, index) => (
          <FolderCard key={folder._id} index={index} folder={folder} />
        ))}
      </div>

      {showPagination && (
        <>
          <div className="section-divider" />
          <TablePagination
            totalRows={data.foldersCount}
            showRowsPerPageOptions={false}
            onChangePage={actions.handleChangePage}
          />
        </>
      )}
    </>
  );
};

export default RootFoldersView;
